import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleParagraph2, IconSuccess16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

const ONLINE_RENTAL_AGREEMENT_LINK = '/rental-online-agreement';

interface IOnlineRentalAgreementLabelProps {
  onShow: () => void;
  onClick: () => void;
}

export const OnlineRentalAgreementLabel: React.FC<IOnlineRentalAgreementLabelProps> = ({ onShow, onClick }) => {
  return (
    <ActionAfterViewObserver callback={onShow} callbackDelay={1500}>
      <div className={styles['wrapper']}>
        <ul>
          <li>
            <IconSuccess16 color="primary_100" />
            <ArticleParagraph2>Проверка собственника</ArticleParagraph2>
          </li>

          <li>
            <IconSuccess16 color="primary_100" />
            <ArticleParagraph2>Защита от рисков</ArticleParagraph2>
          </li>

          <li>
            <IconSuccess16 color="primary_100" />
            <ArticleParagraph2>Все документы онлайн</ArticleParagraph2>
          </li>
        </ul>

        <ArticleParagraph2>
          <a href={ONLINE_RENTAL_AGREEMENT_LINK} onClick={onClick} target="_blank" rel="noreferrer">
            Подробнее о сервисе
          </a>
        </ArticleParagraph2>
      </div>
    </ActionAfterViewObserver>
  );
};
